import React, { useRef } from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './Button';
const HERO_VIDEO_ID = '6Lej-IrwQhQ';
const posterImage = 'https://i.ytimg.com/vi/6Lej-IrwQhQ/maxresdefault.jpg';
export function Hero() {
  const {
    t
  } = useLanguage();
  const heroRef = useRef<HTMLElement>(null);
  const isVisible = useInView(heroRef, {
    margin: '-20% 0px -20% 0px'
  });
  const reduceMotion = useReducedMotion();
  return <section ref={heroRef} id="top" className="relative flex min-h-[92svh] w-full items-end overflow-hidden bg-ink text-ivory lg:min-h-screen" data-id="element-65" data-mp="x8jojrugd0ju">
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-66" data-mp="nb6l7nxgbdm1">
        {reduceMotion || !isVisible ? <img src={posterImage} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-67" data-mp="3d33gp3txj3ne" /> : <iframe src={`https://www.youtube-nocookie.com/embed/${HERO_VIDEO_ID}?autoplay=1&mute=1&loop=1&playlist=${HERO_VIDEO_ID}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&disablekb=1&fs=0`} title={t.hero.videoTitle} allow="autoplay; encrypted-media" className="pointer-events-none absolute left-1/2 top-1/2 h-[177.78vw] min-h-full w-screen min-w-[56.25vh] -translate-x-1/2 -translate-y-1/2 border-0" data-id="element-68" data-mp="3814c5qmge0ov" />}
      </div>
      <div className="absolute inset-0 bg-ink/55" data-id="element-69" data-mp="30g6m9obk478y" />

      <div className="relative z-10 mx-auto w-full max-w-[1440px] px-5 pb-16 pt-32 md:px-8 md:pb-20 lg:px-12 lg:pb-24" data-id="element-70" data-mp="359syjfdt6948">
        <motion.div initial={reduceMotion ? false : {
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: reduceMotion ? 0 : 0.1,
        duration: reduceMotion ? 0 : 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-71" data-mp="2qlelycqlb6ah">
          <h1 className="font-display text-[clamp(3rem,9vw,7.5rem)] font-medium leading-[0.9] tracking-[-0.04em] text-ivory" data-id="element-72" data-mp="2lkqwvwlx8ziw">
            {t.hero.lineOne}<br data-id="element-73" data-mp="s2tenov66frb" />
            <span className="italic text-gold-soft" data-id="element-74" data-mp="s3ckw8bgjfpi">{t.hero.lineTwo}</span>
          </h1>
          <p className="mt-7 max-w-2xl text-base leading-relaxed text-ivory/80 md:text-lg" data-id="element-75" data-mp="n9qhz7v3iq6w">{t.hero.description}</p>
          <p className="mt-4 max-w-2xl text-[10px] font-medium uppercase leading-5 tracking-[0.16em] text-ivory/55" data-id="element-76" data-mp="ichx2zikc81y">{t.hero.categories}</p>
          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-77" data-mp="1b0nilohfy12u">
            <Button href="#quote" data-id="element-78" data-mp="1622hlmud7ddc">{t.navigation.cta}</Button>
            <span className="text-xs uppercase tracking-widest2 text-ivory/50" data-id="element-79" data-mp="162lzx4nxg3rw">{t.hero.location}</span>
          </div>
        </motion.div>

        <a href="#services" aria-label={t.hero.scroll} className="absolute bottom-8 right-5 hidden h-10 w-10 items-center justify-center border border-ivory/30 text-ivory transition-colors duration-200 hover:border-ivory md:flex lg:right-12" data-id="element-80" data-mp="x1eehn6iexf8">
          <ArrowDownIcon size={16} data-id="element-81" data-mp="3hqk747aj58o3" />
        </a>
      </div>
    </section>;
}